import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import api from "../../auth/api"
import { alertSuccess, alertError } from "../../components/Alert";

// Fetch OptionList data
export const fetchOptionListData = createAsyncThunk(
  "options/fetchOptionListData",
  async (_, { rejectWithValue }) => {
    try {
      const response = await api.get("/location/panel/OptionList");
      return response.data; // Adjust based on your API response structure
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

// Update OptionList data
export const updateOptionListData = createAsyncThunk(
  "options/updateOptionListData",
  async (optionListData, { rejectWithValue }) => {
    try {
      const response = await api.patch("/location/panel/OptionList", optionListData);
      alertSuccess(response.data.success);
      return response.data; // Adjust based on your API response structure
    } catch (error) {
      alertError(error.response?.data.errors);
      return rejectWithValue(error.response?.data.errors || error.message);
    }
  }
);

// Add new OptionList data
export const addOptionListData = createAsyncThunk(
  "options/addOptionListData",
  async (newOptionListData, { rejectWithValue }) => {
    try {
      const response = await api.post("/location/panel/OptionList", newOptionListData);
      alertSuccess(response.data.success);
      return response.data; // Adjust based on your API response structure
    } catch (error) {
      alertError(error.response?.data.errors);
      return rejectWithValue(error.response?.data.errors || error.message);
    }
  }
);

const optionsSlice = createSlice({
  name: "options",
  initialState: {
    optionList: null, // Stores the fetched OptionList data
    status: "idle", // 'idle' | 'loading' | 'succeeded' | 'failed'
    error: null, // Stores error messages
  },
  reducers: {
    clearOptionListData(state) {
      state.optionList = null;
      state.status = "idle";
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      // Handle fetchOptionListData
      .addCase(fetchOptionListData.pending, (state) => {
        state.status = "loading";
        state.error = null;
      })
      .addCase(fetchOptionListData.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.optionList = action.payload;
      })
      .addCase(fetchOptionListData.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload;
      })

      // Handle updateOptionListData
      .addCase(updateOptionListData.pending, (state) => {
        state.status = "loading";
        state.error = null;
      })
      .addCase(updateOptionListData.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.optionList = { ...state.optionList, ...action.payload };
      })
      .addCase(updateOptionListData.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload;
      })

      // Handle addOptionListData
      .addCase(addOptionListData.pending, (state) => {
        state.status = "loading";
        state.error = null;
      })
      .addCase(addOptionListData.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.optionList = [...(state.optionList || []), action.payload];
      })
      .addCase(addOptionListData.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload;
      });
  },
});

export const { clearOptionListData } = optionsSlice.actions;

export default optionsSlice.reducer;
